<template>
  <div
      :class="{ 'is-active': active }"
      class="lp-color-field"
      @click="$emit('pick', $event)">
    <span
        v-if="label"
        class="lp-color-field__label">{{ label }}</span>
    <span
        :style="{ background: color }"
        class="lp-color-field__swatch"/>
    <input
        v-if="editable"
        :value="hex"
        class="lp-color-field__hex"
        maxlength="7"
        spellcheck="false"
        @click.stop
        @keydown.enter="commit"
        @blur="commit">
    <span
        v-else
        class="lp-color-field__hex">{{ hex }}</span>
    <span
        v-if="opacity !== null"
        class="lp-color-field__opacity">{{ Math.round(opacity) }}%</span>
  </div>
</template>

<script>
const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

export default {
  name:  'ColorField',
  props: {
    color:    { type: String, default: '#000000' },
    opacity:  { type: Number, default: null },
    editable: { type: Boolean, default: false },
    label:    { type: String, default: '' },
    active:   { type: Boolean, default: false },
  },
  computed: {
    hex() {
      const color = (this.color || '').trim();
      if (HEX.test(color)) {
        return color.replace('#', '').toUpperCase();
      }
      const rgba = color.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
      if (rgba) {
        return rgba.slice(1, 4)
            .map(channel => (`0${Math.min(255, parseInt(channel, 10)).toString(16)}`).slice(-2))
            .join('')
            .toUpperCase();
      }
      return color;
    },
  },
  methods: {
    commit(e) {
      const typed = e.target.value.trim();
      if (!HEX.test(typed)) {
        e.target.value = this.hex;
        return;
      }
      const next = `#${typed.replace('#', '')}`;
      if (next.toUpperCase() !== `#${this.hex}`) {
        this.$emit('input', next);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-color-field {
  display: flex;
  align-items: center;
  gap: 10px;
  height: $lp-control-h;
  padding: 0 10px 0 6px;
  border: 1px solid transparent;
  border-radius: $lp-radius-control;
  background-color: $lp-fill;
  cursor: pointer;

  &:hover {
    border-color: $lp-line;
  }

  &.is-active {
    border-color: $lp-accent;
  }
}

.lp-color-field__label {
  padding-left: 6px;
  font-size: $lp-fs-control;
  color: $lp-ink-2;
}

.lp-color-field__swatch {
  flex: 0 0 24px;
  height: 24px;
  border: 1px solid rgba(20, 22, 27, 0.12);
  border-radius: 6px;
}

.lp-color-field__hex {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: $lp-mono;
  font-size: $lp-fs-control;
  color: $lp-ink;
  text-transform: uppercase;
}

.lp-color-field__opacity {
  padding-left: 10px;
  border-left: 1px solid $lp-line;
  font-family: $lp-mono;
  font-size: $lp-fs-control;
  color: $lp-muted;
}
</style>
